export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Email: { input: any; output: any; }
  File: { input: any; output: any; }
  ObjectId: { input: any; output: any; }
};

export type AdditionalEntityFields = {
  path?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AdminInvitation = {
  __typename?: 'AdminInvitation';
  encryptedToken: Scalars['String']['output'];
  sentToEmail: Scalars['String']['output'];
  timestampActivated?: Maybe<Scalars['DateTime']['output']>;
  timestampLinkFollowed?: Maybe<Scalars['DateTime']['output']>;
  timestampLoggedIn?: Maybe<Scalars['DateTime']['output']>;
  timestampSent: Scalars['DateTime']['output'];
  userIdActivated?: Maybe<Scalars['ObjectId']['output']>;
  userIdLoggedIn?: Maybe<Scalars['ObjectId']['output']>;
};

export type AdminObject = {
  __typename?: 'AdminObject';
  associationsIAdmin: Array<AssociationAdmin>;
  bookletsIAdmin: Array<BookletAdmin>;
  companiesIAdmin: Array<CompanyAdmin>;
  teamMembersIAdmin: Array<TeamMemberAdmin>;
  teamsIAdmin: Array<TeamAdmin>;
  zonesIAdmin: Array<ZoneAdmin>;
};

export enum AssessmentField {
  ExpectedEffect = 'EXPECTED_EFFECT',
  Motivation = 'MOTIVATION',
  Profitability = 'PROFITABILITY',
  Rating = 'RATING',
  TargetGroupAdaptation = 'TARGET_GROUP_ADAPTATION'
}

export type Association = {
  __typename?: 'Association';
  _id: Scalars['ObjectId']['output'];
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminInvitations?: Maybe<Array<Maybe<AdminInvitation>>>;
  adminToken?: Maybe<Scalars['String']['output']>;
  adminUsers: Array<User>;
  agreements: Array<AssociationAgreement>;
  bankInformation?: Maybe<BankInformation>;
  bankInformationEncrypted?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  decryptedAdminToken?: Maybe<Scalars['String']['output']>;
  demoBooklet?: Maybe<DemoBooklet>;
  demoBookletEncrypted?: Maybe<Scalars['String']['output']>;
  logoFullURL?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  paidOutByBooklet?: Maybe<Array<PaidOutAmount>>;
  phone?: Maybe<Scalars['String']['output']>;
  resellerFormAssociations?: Maybe<Scalars['String']['output']>;
  resellerFormTeams?: Maybe<Scalars['String']['output']>;
  resourceBank?: Maybe<ResourceBank>;
  resourceBankEncrypted?: Maybe<Scalars['String']['output']>;
  salesEndDate?: Maybe<Scalars['DateTime']['output']>;
  salesStartDate?: Maybe<Scalars['DateTime']['output']>;
  shopShareDomain?: Maybe<Scalars['String']['output']>;
  shopShareImageURL?: Maybe<Scalars['String']['output']>;
  shopURL?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subshopVisibilityInDashboard?: Maybe<SubshopVisibilityMode>;
  supportableAssociations?: Maybe<Array<Scalars['ObjectId']['output']>>;
  teams: Array<Team>;
  type?: Maybe<Scalars['String']['output']>;
  vatPercentage?: Maybe<Scalars['Int']['output']>;
  visibleOnStartpageOfDomains?: Maybe<Array<Scalars['String']['output']>>;
  zoneId: Scalars['ObjectId']['output'];
};

export type AssociationAdmin = {
  __typename?: 'AssociationAdmin';
  _id: Scalars['ObjectId']['output'];
  logoFullURL?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  zoneId: Scalars['ObjectId']['output'];
  zoneName: Scalars['String']['output'];
};

export type AssociationAgreement = {
  __typename?: 'AssociationAgreement';
  _id: Scalars['ObjectId']['output'];
  activeFrom: Scalars['Int']['output'];
  activeTo: Scalars['Int']['output'];
};

export type AssociationAgreementInput = {
  activeFrom?: InputMaybe<Scalars['Int']['input']>;
  activeTo?: InputMaybe<Scalars['Int']['input']>;
};

export type AssociationStats = {
  __typename?: 'AssociationStats';
  afEarnings: Scalars['Int']['output'];
  association: Association;
  displayName: Scalars['String']['output'];
  earnings: Scalars['Int']['output'];
  isSupportable: Scalars['Boolean']['output'];
  sold: Scalars['Int']['output'];
  supportEarnings: Scalars['Int']['output'];
  supportSold: Scalars['Int']['output'];
};

export type BankInformation = {
  __typename?: 'BankInformation';
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountOwner?: Maybe<Scalars['String']['output']>;
  clearingNumber?: Maybe<Scalars['String']['output']>;
};

export type BankInformationInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountOwner?: InputMaybe<Scalars['String']['input']>;
  clearingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Booklet = {
  __typename?: 'Booklet';
  _id: Scalars['ObjectId']['output'];
  adminEmails?: Maybe<Array<Scalars['String']['output']>>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminUsers?: Maybe<Array<User>>;
  amountOfBookletsOwned?: Maybe<Scalars['Int']['output']>;
  bookletSeries?: Maybe<BookletSeries>;
  bookletSeriesId?: Maybe<Scalars['ObjectId']['output']>;
  buyableFrom: Scalars['DateTime']['output'];
  buyableTo: Scalars['DateTime']['output'];
  calculatedCompanies?: Maybe<Array<CalculatedCompany>>;
  categorySettings?: Maybe<Array<BookletCategorySettings>>;
  categorySponsorsText?: Maybe<Scalars['String']['output']>;
  colorFont?: Maybe<Scalars['String']['output']>;
  colorLeft?: Maybe<Scalars['String']['output']>;
  colorRight?: Maybe<Scalars['String']['output']>;
  colorSalesMaterial?: Maybe<Scalars['String']['output']>;
  couponIds: Array<Scalars['ObjectId']['output']>;
  currentBookletInSeries?: Maybe<Booklet>;
  imageOfBookletInAppURL?: Maybe<Scalars['String']['output']>;
  imageOfSingleBookletInAppURL?: Maybe<Scalars['String']['output']>;
  logoFullURL?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  mainAssociationId?: Maybe<Scalars['ObjectId']['output']>;
  mainSponsorsText?: Maybe<Scalars['String']['output']>;
  nextBookletInSeries?: Maybe<Booklet>;
  popupSponsorsText?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  purchasableThroughAssociations?: Maybe<Array<Scalars['String']['output']>>;
  shopURL?: Maybe<Scalars['String']['output']>;
  showSponsorsPopup?: Maybe<Scalars['Boolean']['output']>;
  soldBooklets?: Maybe<Scalars['Int']['output']>;
  sponsors?: Maybe<Array<Sponsor>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  supportCommissionToAssociation?: Maybe<Scalars['Float']['output']>;
  supportCommissionToMainAssociation?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  textInsidePrintedBooklet?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalCommission?: Maybe<Scalars['Float']['output']>;
  usedOrders?: Maybe<Scalars['Int']['output']>;
  userOwnsBooklet?: Maybe<Scalars['Boolean']['output']>;
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
  zoneId?: Maybe<Scalars['ObjectId']['output']>;
};

export type BookletAdmin = {
  __typename?: 'BookletAdmin';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type BookletCategorySettings = {
  __typename?: 'BookletCategorySettings';
  categoryId: Scalars['ObjectId']['output'];
  color?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type BookletCategorySettingsInput = {
  categoryId: Scalars['ObjectId']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type BookletCompanyReview = {
  __typename?: 'BookletCompanyReview';
  _id: Scalars['ObjectId']['output'];
  approvedByAdmin?: Maybe<Scalars['String']['output']>;
  approvedDate?: Maybe<Scalars['DateTime']['output']>;
  bookletId: Scalars['ObjectId']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  company: Company;
  coupons: Array<Coupon>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  messageToCompany?: Maybe<Scalars['String']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  sentToEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  token: Scalars['String']['output'];
};

export type BookletResellerStats = {
  __typename?: 'BookletResellerStats';
  associations: Array<AssociationStats>;
  commissionSettings: CommissionSettings;
  teamMembers: Array<TeamMemberStats>;
  teams: Array<TeamStats>;
  totals: ResellerStatTotals;
};

export type BookletResellers = {
  __typename?: 'BookletResellers';
  associations: Array<Association>;
  mainAssociation?: Maybe<Association>;
  teamMembers: Array<TeamMember>;
  teams: Array<Team>;
};

export type BookletSeries = {
  __typename?: 'BookletSeries';
  _id: Scalars['ObjectId']['output'];
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminUsers: Array<User>;
  booklets: Array<Booklet>;
  colorFont?: Maybe<Scalars['String']['output']>;
  colorLeft?: Maybe<Scalars['String']['output']>;
  colorRight?: Maybe<Scalars['String']['output']>;
  colorSalesMaterial?: Maybe<Scalars['String']['output']>;
  currentBooklet?: Maybe<Booklet>;
  defaultValidityMonths?: Maybe<Scalars['Int']['output']>;
  logoFullURL?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  mainAssociationId?: Maybe<Scalars['ObjectId']['output']>;
  name: Scalars['String']['output'];
  nextBooklet?: Maybe<Booklet>;
  postIds: Array<Scalars['ObjectId']['output']>;
  posts: Array<Post>;
  postsButtonLabel?: Maybe<Scalars['String']['output']>;
  postsButtonLink?: Maybe<Scalars['String']['output']>;
  postsTitle?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  purchasableThroughAssociations?: Maybe<Array<Scalars['ObjectId']['output']>>;
  supportCommissionToAssociation?: Maybe<Scalars['Float']['output']>;
  supportCommissionToMainAssociation?: Maybe<Scalars['Float']['output']>;
  totalCommission?: Maybe<Scalars['Float']['output']>;
  totalSoldBooklets?: Maybe<Scalars['Int']['output']>;
  zoneId: Scalars['ObjectId']['output'];
};


export type BookletSeriesPostsArgs = {
  filter?: InputMaybe<Array<PostValidity>>;
};

export type Broadcast = {
  __typename?: 'Broadcast';
  _id: Scalars['ObjectId']['output'];
  broadcastPeriod: BroadcastPeriod;
  broadcastType: Scalars['String']['output'];
  content: Content;
  filters?: Maybe<Filters>;
  notification?: Maybe<Notification>;
  readBy: Array<Maybe<ReadBy>>;
};

export type BroadcastPeriod = {
  __typename?: 'BroadcastPeriod';
  customStartDate?: Maybe<Scalars['DateTime']['output']>;
  expiresInDays?: Maybe<Scalars['Int']['output']>;
  relativeToEndOfBookletDays?: Maybe<Scalars['Int']['output']>;
  rule: Scalars['String']['output'];
};

export type BroadcastPeriodInput = {
  customStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  relativeToEndOfBookletDays?: InputMaybe<Scalars['Int']['input']>;
  rule: Scalars['String']['input'];
};

export type Button = {
  __typename?: 'Button';
  closesModal: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ButtonInput = {
  closesModal: Scalars['Boolean']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CachedCoupon = {
  __typename?: 'CachedCoupon';
  activationDateTime: Scalars['DateTime']['output'];
  orderId: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

export type CachedCouponInput = {
  activationDateTime: Scalars['DateTime']['input'];
  orderId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type CalculatedCity = {
  __typename?: 'CalculatedCity';
  _id: Scalars['ObjectId']['output'];
  activeFrom?: Maybe<Scalars['Int']['output']>;
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminUsers: Array<User>;
  bookletColorFont?: Maybe<Scalars['String']['output']>;
  bookletColorLeft?: Maybe<Scalars['String']['output']>;
  bookletColorRight?: Maybe<Scalars['String']['output']>;
  couponBookletsBoughtByUser?: Maybe<Scalars['Int']['output']>;
  includeInAllBooklets?: Maybe<Scalars['Boolean']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CalculatedCompany = {
  __typename?: 'CalculatedCompany';
  _id: Scalars['ObjectId']['output'];
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminUsers: Array<User>;
  agreements: Array<CompanyAgreement>;
  calculatedCoupons?: Maybe<Array<Maybe<CalculatedCoupon>>>;
  categoryId: Scalars['Int']['output'];
  companyCategoryId: Scalars['ObjectId']['output'];
  earlyBird?: Maybe<Scalars['Boolean']['output']>;
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  logoFullURL?: Maybe<Scalars['String']['output']>;
  logoRoundedFullURL?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  mainSponsor?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['Int']['output'];
  visitAddress?: Maybe<Address>;
  websiteURL?: Maybe<Scalars['String']['output']>;
  zoneId: Scalars['ObjectId']['output'];
};

export type CalculatedCoupon = {
  __typename?: 'CalculatedCoupon';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  assessment?: Maybe<CouponAssessment>;
  availableByUser?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  codeType?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['ObjectId']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  couponTimeLeftDurationMs?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  estimatedSavings?: Maybe<Scalars['Float']['output']>;
  imageFullURL?: Maybe<Scalars['String']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
  lastUsedCoupon?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  productLink?: Maybe<Scalars['String']['output']>;
  smallTitle?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
  usedByUser?: Maybe<Scalars['Int']['output']>;
  usedCache?: Maybe<Array<Maybe<CachedCoupon>>>;
};

export type CalculatedUser = {
  __typename?: 'CalculatedUser';
  orders?: Maybe<Array<Maybe<Order>>>;
  user?: Maybe<User>;
};

export type City = {
  __typename?: 'City';
  _id: Scalars['ObjectId']['output'];
  activeFrom?: Maybe<Scalars['Int']['output']>;
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminUsers: Array<User>;
  bookletColorFont?: Maybe<Scalars['String']['output']>;
  bookletColorLeft?: Maybe<Scalars['String']['output']>;
  bookletColorRight?: Maybe<Scalars['String']['output']>;
  cityPrice?: Maybe<Scalars['Float']['output']>;
  cityTax?: Maybe<Scalars['Float']['output']>;
  includeInAllBooklets?: Maybe<Scalars['Boolean']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

export type CloudinaryFile = {
  __typename?: 'CloudinaryFile';
  createdAt?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  partURL?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  secureURL?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Code = {
  __typename?: 'Code';
  _id: Scalars['ObjectId']['output'];
  code: Scalars['String']['output'];
  couponId: Scalars['ObjectId']['output'];
};

export type CommissionSettings = {
  __typename?: 'CommissionSettings';
  supportCommissionToAssociation: Scalars['Int']['output'];
  supportCommissionToMainAssociation: Scalars['Int']['output'];
  totalCommission: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  _id: Scalars['ObjectId']['output'];
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminUsers: Array<User>;
  agreements: Array<CompanyAgreement>;
  calculatedCoupons?: Maybe<Array<Maybe<CalculatedCoupon>>>;
  categoryId: Scalars['Int']['output'];
  companyCategoryId: Scalars['ObjectId']['output'];
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactPerson?: Maybe<Scalars['String']['output']>;
  earlyBird?: Maybe<Scalars['Boolean']['output']>;
  isFavourite: Scalars['Boolean']['output'];
  logoFullURL?: Maybe<Scalars['String']['output']>;
  logoRoundedFullURL?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  mainSponsor?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  tags?: Maybe<Array<Tag>>;
  typeId: Scalars['Int']['output'];
  visitAddress?: Maybe<Address>;
  websiteURL?: Maybe<Scalars['String']['output']>;
  zoneId: Scalars['ObjectId']['output'];
};

export type CompanyAdmin = {
  __typename?: 'CompanyAdmin';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  zoneId: Scalars['ObjectId']['output'];
  zoneName: Scalars['String']['output'];
};

export type CompanyAgreement = {
  __typename?: 'CompanyAgreement';
  _id: Scalars['ObjectId']['output'];
  activeFrom: Scalars['Int']['output'];
  activeTo: Scalars['Int']['output'];
  coupons: Array<Coupon>;
};

export type CompanyAgreementInput = {
  activeFrom?: InputMaybe<Scalars['Int']['input']>;
  activeTo?: InputMaybe<Scalars['Int']['input']>;
  coupons?: InputMaybe<Array<InputMaybe<CouponInput>>>;
};

export type CompanyCategory = {
  __typename?: 'CompanyCategory';
  _id: Scalars['ObjectId']['output'];
  iconPath?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CompanyInput = {
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  adminIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  agreements?: InputMaybe<Array<CompanyAgreementInput>>;
  categoryId: Scalars['Int']['input'];
  earlyBird?: InputMaybe<Scalars['Boolean']['input']>;
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  logoFullURL?: InputMaybe<Scalars['String']['input']>;
  logoRoundedFullURL?: InputMaybe<Scalars['String']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  mainSponsor?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  typeId: Scalars['Int']['input'];
  visitAddress?: InputMaybe<AddressInput>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type CompanyType = {
  __typename?: 'CompanyType';
  _id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Content = {
  __typename?: 'Content';
  fullScreen: Scalars['Boolean']['output'];
  slides: Array<Slide>;
  view: Scalars['String']['output'];
};

export type ContentInput = {
  fullScreen: Scalars['Boolean']['input'];
  slides: Array<SlideInput>;
  view: Scalars['String']['input'];
};

export type Coupon = {
  __typename?: 'Coupon';
  _id: Scalars['ObjectId']['output'];
  assessment?: Maybe<CouponAssessment>;
  code?: Maybe<Scalars['String']['output']>;
  codeType?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ObjectId']['output'];
  context?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  estimatedSavings?: Maybe<Scalars['Float']['output']>;
  imageFullURL?: Maybe<Scalars['String']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  productLink?: Maybe<Scalars['String']['output']>;
  smallTitle: Scalars['String']['output'];
  terms?: Maybe<Scalars['String']['output']>;
  usedCache?: Maybe<Array<Maybe<CachedCoupon>>>;
  usedCouponsResult: UsedCouponsResult;
};

export type CouponAssessment = {
  __typename?: 'CouponAssessment';
  expectedEffect?: Maybe<Scalars['String']['output']>;
  motivation?: Maybe<Scalars['String']['output']>;
  profitability?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  shouldShowAssessment?: Maybe<Scalars['Boolean']['output']>;
  targetGroupAdaptation?: Maybe<Scalars['String']['output']>;
};

export type CouponAssessmentInput = {
  expectedEffect?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  profitability?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  shouldShowAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  targetGroupAdaptation?: InputMaybe<Scalars['String']['input']>;
};

export type CouponInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assessment?: InputMaybe<CouponAssessmentInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  codeType?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  estimatedSavings?: InputMaybe<Scalars['Float']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  productLink?: InputMaybe<Scalars['String']['input']>;
  smallTitle?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  usedCache?: InputMaybe<Array<InputMaybe<CachedCouponInput>>>;
};

export type CouponPosition = {
  __typename?: 'CouponPosition';
  _id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DemoBooklet = {
  __typename?: 'DemoBooklet';
  email?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
};

export type DemoBookletInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type EarlyBird = {
  __typename?: 'EarlyBird';
  _id: Scalars['ObjectId']['output'];
  imageURL: Scalars['String']['output'];
  period: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  showInOwned: Scalars['Boolean']['output'];
};

export type EmailRecord = {
  __typename?: 'EmailRecord';
  _id: Scalars['ObjectId']['output'];
  attachment: Scalars['Boolean']['output'];
  booklet?: Maybe<Booklet>;
  bookletId: Scalars['ObjectId']['output'];
  company?: Maybe<Company>;
  companyId: Scalars['ObjectId']['output'];
  from?: Maybe<Scalars['Email']['output']>;
  message: Scalars['String']['output'];
  messageType: Scalars['String']['output'];
  postalId: Scalars['String']['output'];
  review?: Maybe<BookletCompanyReview>;
  reviewId?: Maybe<Scalars['ObjectId']['output']>;
  sent: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  teamId?: Maybe<Scalars['ObjectId']['output']>;
  teamMemberId?: Maybe<Scalars['ObjectId']['output']>;
  title: Scalars['String']['output'];
  to: Scalars['Email']['output'];
  user?: Maybe<User>;
  userId: Scalars['ObjectId']['output'];
  zoneId: Scalars['ObjectId']['output'];
};

export type Filters = {
  __typename?: 'Filters';
  androidVersion?: Maybe<Version>;
  appVersion?: Maybe<Version>;
  bookletIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  iOSVersion?: Maybe<Version>;
  platform?: Maybe<Scalars['String']['output']>;
};

export type FiltersInput = {
  androidVersion?: InputMaybe<VersionInput>;
  appVersion?: InputMaybe<VersionInput>;
  bookletIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  iOSVersion?: InputMaybe<VersionInput>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type MergedBooklets = {
  __typename?: 'MergedBooklets';
  calculatedCompanies: Array<CalculatedCompany>;
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  userOwnsBooklet: Scalars['Boolean']['output'];
};

export type Message = {
  __typename?: 'Message';
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  filter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type MigrationResult = {
  __typename?: 'MigrationResult';
  bookletsMigrated: Scalars['Int']['output'];
  details: Array<Scalars['String']['output']>;
  seriesCreated: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateAccount: User;
  addAssociationAgreement: Association;
  addCompanyToFavourites?: Maybe<User>;
  addMeAsAssociationAdmin: Association;
  addMeAsAssociationAdminByInvitation: Association;
  addMeAsTeamAdmin: Team;
  addMeAsTeamAdminByInvitation: Team;
  addMeAsTeamMemberAdmin: TeamMember;
  addMeAsTeamMemberAdminByInvitation: TeamMember;
  addPostToSeries: BookletSeries;
  approveTeamMember?: Maybe<TeamMember>;
  changePasswordWithTmpPassword: User;
  cloneBooklet: Booklet;
  createAssociation: Association;
  createBooklet: Booklet;
  createBookletCompanyReview: BookletCompanyReview;
  createBookletSeries: BookletSeries;
  createBroadcast: Broadcast;
  createCity: City;
  createCompany: Company;
  createCompanyCategory: CompanyCategory;
  createCompletedOrders: Array<Order>;
  createCoupon: Coupon;
  createEarlyBird: EarlyBird;
  createForgotPasswordLinkForUser?: Maybe<Scalars['String']['output']>;
  createMyOrder: Order;
  createOrder: Order;
  createPost: Post;
  createTag: Tag;
  createTeam?: Maybe<Team>;
  createTeamMember?: Maybe<TeamMember>;
  createTeamMemberAndAddMeAsTeamMemberAdmin: TeamMember;
  createTokensForAssociations?: Maybe<Scalars['Boolean']['output']>;
  createTokensForTeamMembers?: Maybe<Scalars['Boolean']['output']>;
  createTokensForTeams?: Maybe<Scalars['Boolean']['output']>;
  createUsedCoupon: UsedCoupon;
  createUser: Scalars['String']['output'];
  createZone: Zone;
  deActivateMyUser?: Maybe<User>;
  deleteAssociationAdminInvitation: Association;
  deleteAssociationAgreement: Association;
  deleteBookletCompanyReview: BookletCompanyReview;
  deleteBookletSeries: Scalars['Boolean']['output'];
  deleteBroadcast: Broadcast;
  deleteCompanyCategory: Scalars['Boolean']['output'];
  deleteMyUser?: Maybe<Scalars['Boolean']['output']>;
  deletePost: Post;
  deleteTag: Tag;
  deleteTeamAdminInvitation: Team;
  deleteTeamMember?: Maybe<Scalars['Boolean']['output']>;
  deleteTeamMemberAdminInvitation: TeamMember;
  extendSalesPeriod: Team;
  forgotPassword?: Maybe<Scalars['Boolean']['output']>;
  generateCompletedOrderBatchPDF: Scalars['String']['output'];
  generateCompletedOrderPDF: Scalars['String']['output'];
  generateCouponSuggestions: Array<Coupon>;
  generatePrintedCompletedOrderBatchPDF: Scalars['String']['output'];
  generateSalesMaterial: Array<Scalars['String']['output']>;
  inviteAssociationAdmin: Scalars['String']['output'];
  inviteTeamAdmin: Scalars['String']['output'];
  inviteTeamMemberAdmin: Scalars['String']['output'];
  logAssociationInvitationAction: Association;
  logTeamInvitationAction: Team;
  logTeamMemberInvitationAction: TeamMember;
  login: Scalars['String']['output'];
  migrateBookletsToSeries: MigrationResult;
  moveTeamMemberSales?: Maybe<Scalars['Boolean']['output']>;
  normalizeCouponPositions: Array<Maybe<Coupon>>;
  payWithSwish: Scalars['Boolean']['output'];
  payWithSwishMobile: Scalars['String']['output'];
  readBroadcast: Scalars['String']['output'];
  removeCoupon: Coupon;
  removePostFromSeries: BookletSeries;
  reorderSeriesPosts: BookletSeries;
  sendEmail: Scalars['Boolean']['output'];
  sendOrderBatchPdfLink: Scalars['Boolean']['output'];
  sendOrderPdfLink: Scalars['Boolean']['output'];
  sendTeamSalesThankYouEmail: Scalars['Boolean']['output'];
  sendTestEmails?: Maybe<Scalars['Boolean']['output']>;
  singleFileUpload: CloudinaryFile;
  toggleCompanyFavourite?: Maybe<Company>;
  updateAssociation: Association;
  updateAssociationAgreement: Association;
  updateBooklet: Booklet;
  updateBookletCompanyReview: BookletCompanyReview;
  updateBookletCompanyReviewWithToken: BookletCompanyReview;
  updateBookletSeries: BookletSeries;
  updateBroadcast: Broadcast;
  updateCity: City;
  updateCompany: Company;
  updateCompanyCategory: CompanyCategory;
  updateCoupon: Coupon;
  updateCouponPositions: Array<Maybe<Coupon>>;
  updateMyUser?: Maybe<User>;
  updateOrder: Order;
  updateOrderOwner: Order;
  updateOrderSupportAssociation: Order;
  updatePost: Post;
  updateTag: Tag;
  updateTeam?: Maybe<Team>;
  updateTeamMember?: Maybe<TeamMember>;
  updateUsedCoupon: UsedCoupon;
  updateUser?: Maybe<User>;
  updateZone: Zone;
};


export type MutationActivateAccountArgs = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  termsApproved?: InputMaybe<Scalars['Boolean']['input']>;
  tmpPassword: Scalars['String']['input'];
};


export type MutationAddAssociationAgreementArgs = {
  activeFrom?: InputMaybe<Scalars['Int']['input']>;
  activeTo: Scalars['Int']['input'];
  associationId: Scalars['ObjectId']['input'];
};


export type MutationAddCompanyToFavouritesArgs = {
  companyId: Scalars['ObjectId']['input'];
};


export type MutationAddMeAsAssociationAdminArgs = {
  adminToken: Scalars['String']['input'];
  associationId: Scalars['ObjectId']['input'];
};


export type MutationAddMeAsAssociationAdminByInvitationArgs = {
  adminToken: Scalars['String']['input'];
  objectId: Scalars['ObjectId']['input'];
};


export type MutationAddMeAsTeamAdminArgs = {
  portalUrlForEmails: Scalars['String']['input'];
  teamAdminToken: Scalars['String']['input'];
  teamId: Scalars['ObjectId']['input'];
};


export type MutationAddMeAsTeamAdminByInvitationArgs = {
  adminToken: Scalars['String']['input'];
  objectId: Scalars['ObjectId']['input'];
};


export type MutationAddMeAsTeamMemberAdminArgs = {
  adminToken: Scalars['String']['input'];
  teamMemberId: Scalars['ObjectId']['input'];
};


export type MutationAddMeAsTeamMemberAdminByInvitationArgs = {
  adminToken: Scalars['String']['input'];
  objectId: Scalars['ObjectId']['input'];
};


export type MutationAddPostToSeriesArgs = {
  postId: Scalars['ObjectId']['input'];
  seriesId: Scalars['ObjectId']['input'];
};


export type MutationApproveTeamMemberArgs = {
  adminToken: Scalars['String']['input'];
  teamMemberId: Scalars['ObjectId']['input'];
};


export type MutationChangePasswordWithTmpPasswordArgs = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  tmpPassword: Scalars['String']['input'];
};


export type MutationCloneBookletArgs = {
  _id: Scalars['ObjectId']['input'];
  buyableFrom: Scalars['DateTime']['input'];
  buyableTo: Scalars['DateTime']['input'];
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
};


export type MutationCreateAssociationArgs = {
  agreements?: InputMaybe<Array<AssociationAgreementInput>>;
  bankInformation?: InputMaybe<BankInformationInput>;
  billingAddress?: InputMaybe<AddressInput>;
  demoBooklet?: InputMaybe<DemoBookletInput>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  resellerFormAssociations?: InputMaybe<Scalars['String']['input']>;
  resellerFormTeams?: InputMaybe<Scalars['String']['input']>;
  resourceBank?: InputMaybe<ResourceBankInput>;
  salesEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  salesStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  shopShareDomain?: InputMaybe<Scalars['String']['input']>;
  shopShareImageURL?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subshopVisibilityInDashboard?: InputMaybe<SubshopVisibilityMode>;
  supportableAssociations?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  vatPercentage?: InputMaybe<Scalars['Int']['input']>;
  visibleOnStartpageOfDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneId: Scalars['ObjectId']['input'];
};


export type MutationCreateBookletArgs = {
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  bookletSeriesId: Scalars['ObjectId']['input'];
  buyableFrom: Scalars['DateTime']['input'];
  buyableTo: Scalars['DateTime']['input'];
  categorySettings?: InputMaybe<Array<InputMaybe<BookletCategorySettingsInput>>>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorLeft?: InputMaybe<Scalars['String']['input']>;
  colorRight?: InputMaybe<Scalars['String']['input']>;
  colorSalesMaterial?: InputMaybe<Scalars['String']['input']>;
  imageOfBookletInAppURL?: InputMaybe<Scalars['String']['input']>;
  imageOfSingleBookletInAppURL?: InputMaybe<Scalars['String']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  mainAssociationId?: InputMaybe<Scalars['ObjectId']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  purchasableThroughAssociations?: InputMaybe<Array<Scalars['String']['input']>>;
  sponsors?: InputMaybe<Array<InputMaybe<SponsorInput>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  supportCommissionToAssociation?: InputMaybe<Scalars['Float']['input']>;
  supportCommissionToMainAssociation?: InputMaybe<Scalars['Float']['input']>;
  textInsidePrintedBooklet?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalCommission?: InputMaybe<Scalars['Float']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
  zoneId: Scalars['ObjectId']['input'];
};


export type MutationCreateBookletCompanyReviewArgs = {
  bookletId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
  couponIds: Array<Scalars['ObjectId']['input']>;
  messageToCompany?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  sentToEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  shouldSendMail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateBookletSeriesArgs = {
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorLeft?: InputMaybe<Scalars['String']['input']>;
  colorRight?: InputMaybe<Scalars['String']['input']>;
  colorSalesMaterial?: InputMaybe<Scalars['String']['input']>;
  defaultValidityMonths?: InputMaybe<Scalars['Int']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  mainAssociationId?: InputMaybe<Scalars['ObjectId']['input']>;
  name: Scalars['String']['input'];
  postsButtonLabel?: InputMaybe<Scalars['String']['input']>;
  postsButtonLink?: InputMaybe<Scalars['String']['input']>;
  postsTitle?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  purchasableThroughAssociations?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  supportCommissionToAssociation?: InputMaybe<Scalars['Float']['input']>;
  supportCommissionToMainAssociation?: InputMaybe<Scalars['Float']['input']>;
  totalCommission?: InputMaybe<Scalars['Float']['input']>;
  zoneId: Scalars['ObjectId']['input'];
};


export type MutationCreateBroadcastArgs = {
  broadcastPeriod: BroadcastPeriodInput;
  broadcastType: Scalars['String']['input'];
  content: ContentInput;
  filters?: InputMaybe<FiltersInput>;
  notification?: InputMaybe<NotificationInput>;
};


export type MutationCreateCityArgs = {
  activeFrom: Scalars['Int']['input'];
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  bookletColorFont?: InputMaybe<Scalars['String']['input']>;
  bookletColorLeft?: InputMaybe<Scalars['String']['input']>;
  bookletColorRight?: InputMaybe<Scalars['String']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateCompanyArgs = {
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  agreements?: InputMaybe<Array<InputMaybe<CompanyAgreementInput>>>;
  companyCategoryId: Scalars['ObjectId']['input'];
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  contactMobile?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  earlyBird?: InputMaybe<Scalars['Boolean']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  mainSponsor?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  typeId: Scalars['Int']['input'];
  visitAddress?: InputMaybe<AddressInput>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ObjectId']['input'];
};


export type MutationCreateCompanyCategoryArgs = {
  iconPath?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateCompletedOrdersArgs = {
  amount: Scalars['Int']['input'];
  associationId?: InputMaybe<Scalars['ObjectId']['input']>;
  bookletId: Scalars['ObjectId']['input'];
  teamId?: InputMaybe<Scalars['ObjectId']['input']>;
  teamMemberId?: InputMaybe<Scalars['ObjectId']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateCouponArgs = {
  assessment?: InputMaybe<CouponAssessmentInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  codeType?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ObjectId']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  estimatedSavings?: InputMaybe<Scalars['Float']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  productLink?: InputMaybe<Scalars['String']['input']>;
  smallTitle: Scalars['String']['input'];
  terms?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEarlyBirdArgs = {
  imageURL: Scalars['String']['input'];
  period: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  showInOwned: Scalars['Boolean']['input'];
};


export type MutationCreateForgotPasswordLinkForUserArgs = {
  email: Scalars['Email']['input'];
};


export type MutationCreateMyOrderArgs = {
  associationId?: InputMaybe<Scalars['ObjectId']['input']>;
  bookletId: Scalars['ObjectId']['input'];
  teamId?: InputMaybe<Scalars['ObjectId']['input']>;
  teamMemberId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationCreateOrderArgs = {
  associationId?: InputMaybe<Scalars['ObjectId']['input']>;
  bookletId: Scalars['ObjectId']['input'];
  supportAssociationId?: InputMaybe<Scalars['ObjectId']['input']>;
  teamId?: InputMaybe<Scalars['ObjectId']['input']>;
  teamMemberId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationCreatePostArgs = {
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
  zoneId: Scalars['ObjectId']['input'];
};


export type MutationCreateTagArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  zoneId: Scalars['ObjectId']['input'];
};


export type MutationCreateTeamArgs = {
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  associationId: Scalars['ObjectId']['input'];
  name: Scalars['String']['input'];
  salesEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  salesStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTeamMemberArgs = {
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstname: Scalars['String']['input'];
  isApprovedByGuardian?: InputMaybe<Scalars['Boolean']['input']>;
  lastname: Scalars['String']['input'];
  teamId: Scalars['ObjectId']['input'];
};


export type MutationCreateTeamMemberAndAddMeAsTeamMemberAdminArgs = {
  firstLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  teamId: Scalars['ObjectId']['input'];
  teamMemberCreationToken: Scalars['String']['input'];
};


export type MutationCreateTokensForAssociationsArgs = {
  regenAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateTokensForTeamMembersArgs = {
  regenAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateTokensForTeamsArgs = {
  regenAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateUsedCouponArgs = {
  bookletId: Scalars['ObjectId']['input'];
  couponId: Scalars['ObjectId']['input'];
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  longExpiry: Scalars['Boolean']['input'];
  marketingApprovedVersion?: InputMaybe<Scalars['Int']['input']>;
  password: Scalars['String']['input'];
  termsApprovedVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateZoneArgs = {
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};


export type MutationDeActivateMyUserArgs = {
  currentPassword: Scalars['String']['input'];
};


export type MutationDeleteAssociationAdminInvitationArgs = {
  associationId: Scalars['ObjectId']['input'];
  email: Scalars['Email']['input'];
};


export type MutationDeleteAssociationAgreementArgs = {
  agreementId: Scalars['ObjectId']['input'];
  associationId: Scalars['ObjectId']['input'];
};


export type MutationDeleteBookletCompanyReviewArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeleteBookletSeriesArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeleteBroadcastArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeleteCompanyCategoryArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeletePostArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeleteTagArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeleteTeamAdminInvitationArgs = {
  email: Scalars['Email']['input'];
  teamId: Scalars['ObjectId']['input'];
};


export type MutationDeleteTeamMemberArgs = {
  teamMemberId: Scalars['ObjectId']['input'];
};


export type MutationDeleteTeamMemberAdminInvitationArgs = {
  email: Scalars['Email']['input'];
  teamMemberId: Scalars['ObjectId']['input'];
};


export type MutationExtendSalesPeriodArgs = {
  extensionToken?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ObjectId']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateCompletedOrderBatchPdfArgs = {
  batchLabel: Scalars['String']['input'];
  bookletId: Scalars['ObjectId']['input'];
  mode: Scalars['String']['input'];
};


export type MutationGenerateCompletedOrderPdfArgs = {
  bookletId: Scalars['ObjectId']['input'];
  encryptedOrderCode: Scalars['String']['input'];
  orderId: Scalars['ObjectId']['input'];
};


export type MutationGenerateCouponSuggestionsArgs = {
  assessmentFields?: InputMaybe<Array<AssessmentField>>;
  companyId: Scalars['ObjectId']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  contexts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  couponId?: InputMaybe<Scalars['ObjectId']['input']>;
  existingCouponData?: InputMaybe<CouponInput>;
  quantity: Scalars['Int']['input'];
  regenerateType?: InputMaybe<RegenerateType>;
};


export type MutationGeneratePrintedCompletedOrderBatchPdfArgs = {
  batchLabel: Scalars['String']['input'];
  bookletId: Scalars['ObjectId']['input'];
  mode: Scalars['String']['input'];
};


export type MutationGenerateSalesMaterialArgs = {
  associationId?: InputMaybe<Scalars['ObjectId']['input']>;
  bookletId: Scalars['ObjectId']['input'];
  posterType?: InputMaybe<PosterType>;
  teamId?: InputMaybe<Scalars['ObjectId']['input']>;
  type: Scalars['String']['input'];
};


export type MutationInviteAssociationAdminArgs = {
  associationId: Scalars['ObjectId']['input'];
  email: Scalars['Email']['input'];
  portalUrlForEmails: Scalars['String']['input'];
};


export type MutationInviteTeamAdminArgs = {
  email: Scalars['Email']['input'];
  portalUrlForEmails: Scalars['String']['input'];
  teamId: Scalars['ObjectId']['input'];
};


export type MutationInviteTeamMemberAdminArgs = {
  email: Scalars['Email']['input'];
  portalUrlForEmails: Scalars['String']['input'];
  teamMemberId: Scalars['ObjectId']['input'];
};


export type MutationLogAssociationInvitationActionArgs = {
  action: Scalars['String']['input'];
  adminToken: Scalars['String']['input'];
  objectId: Scalars['ObjectId']['input'];
};


export type MutationLogTeamInvitationActionArgs = {
  action: Scalars['String']['input'];
  adminToken: Scalars['String']['input'];
  objectId: Scalars['ObjectId']['input'];
};


export type MutationLogTeamMemberInvitationActionArgs = {
  action: Scalars['String']['input'];
  adminToken: Scalars['String']['input'];
  objectId: Scalars['ObjectId']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  longExpiry: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
};


export type MutationMoveTeamMemberSalesArgs = {
  fromTeamMemberId: Scalars['ObjectId']['input'];
  toTeamMemberId: Scalars['ObjectId']['input'];
};


export type MutationNormalizeCouponPositionsArgs = {
  companyId: Scalars['ObjectId']['input'];
};


export type MutationPayWithSwishArgs = {
  orderId: Scalars['ObjectId']['input'];
  payerAlias: Scalars['String']['input'];
};


export type MutationPayWithSwishMobileArgs = {
  orderId: Scalars['ObjectId']['input'];
};


export type MutationReadBroadcastArgs = {
  bookletId?: InputMaybe<Scalars['ObjectId']['input']>;
  broadcastId: Scalars['ObjectId']['input'];
  expoToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveCouponArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationRemovePostFromSeriesArgs = {
  postId: Scalars['ObjectId']['input'];
  seriesId: Scalars['ObjectId']['input'];
};


export type MutationReorderSeriesPostsArgs = {
  postIds: Array<Scalars['ObjectId']['input']>;
  seriesId: Scalars['ObjectId']['input'];
};


export type MutationSendEmailArgs = {
  bookletId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
  emails: Array<Scalars['Email']['input']>;
  message: Scalars['String']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  zoneId: Scalars['ObjectId']['input'];
};


export type MutationSendOrderBatchPdfLinkArgs = {
  batchLabel: Scalars['String']['input'];
  bookletId: Scalars['ObjectId']['input'];
  email: Scalars['Email']['input'];
  portalUrlForEmails: Scalars['String']['input'];
};


export type MutationSendOrderPdfLinkArgs = {
  bookletId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
  emails: Array<Scalars['Email']['input']>;
  message: Scalars['String']['input'];
  orderCode: Scalars['String']['input'];
  orderId: Scalars['ObjectId']['input'];
  portalUrlForEmails: Scalars['String']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  zoneId: Scalars['ObjectId']['input'];
};


export type MutationSendTeamSalesThankYouEmailArgs = {
  teamId: Scalars['ObjectId']['input'];
};


export type MutationSendTestEmailsArgs = {
  email: Scalars['Email']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSingleFileUploadArgs = {
  file: Scalars['File']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleCompanyFavouriteArgs = {
  companyId: Scalars['ObjectId']['input'];
};


export type MutationUpdateAssociationArgs = {
  _id: Scalars['ObjectId']['input'];
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  bankInformation?: InputMaybe<BankInformationInput>;
  billingAddress?: InputMaybe<AddressInput>;
  demoBooklet?: InputMaybe<DemoBookletInput>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paidOutByBooklet?: InputMaybe<Array<PaidOutAmountInput>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  resellerFormAssociations?: InputMaybe<Scalars['String']['input']>;
  resellerFormTeams?: InputMaybe<Scalars['String']['input']>;
  resourceBank?: InputMaybe<ResourceBankInput>;
  salesEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  salesStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  shopShareDomain?: InputMaybe<Scalars['String']['input']>;
  shopShareImageURL?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subshopVisibilityInDashboard?: InputMaybe<SubshopVisibilityMode>;
  supportableAssociations?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  vatPercentage?: InputMaybe<Scalars['Int']['input']>;
  visibleOnStartpageOfDomains?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateAssociationAgreementArgs = {
  activeFrom?: InputMaybe<Scalars['Int']['input']>;
  activeTo?: InputMaybe<Scalars['Int']['input']>;
  agreementId: Scalars['ObjectId']['input'];
  associationId: Scalars['ObjectId']['input'];
};


export type MutationUpdateBookletArgs = {
  _id: Scalars['ObjectId']['input'];
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  bookletSeriesId?: InputMaybe<Scalars['ObjectId']['input']>;
  buyableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  buyableTo?: InputMaybe<Scalars['DateTime']['input']>;
  categorySettings?: InputMaybe<Array<InputMaybe<BookletCategorySettingsInput>>>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorLeft?: InputMaybe<Scalars['String']['input']>;
  colorRight?: InputMaybe<Scalars['String']['input']>;
  colorSalesMaterial?: InputMaybe<Scalars['String']['input']>;
  couponIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageOfBookletInAppURL?: InputMaybe<Scalars['String']['input']>;
  imageOfSingleBookletInAppURL?: InputMaybe<Scalars['String']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  mainAssociationId?: InputMaybe<Scalars['ObjectId']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  purchasableThroughAssociations?: InputMaybe<Array<Scalars['String']['input']>>;
  sponsors?: InputMaybe<Array<InputMaybe<SponsorInput>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  supportCommissionToAssociation?: InputMaybe<Scalars['Float']['input']>;
  supportCommissionToMainAssociation?: InputMaybe<Scalars['Float']['input']>;
  textInsidePrintedBooklet?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalCommission?: InputMaybe<Scalars['Float']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateBookletCompanyReviewArgs = {
  _id: Scalars['ObjectId']['input'];
  approvedByAdmin?: InputMaybe<Scalars['String']['input']>;
  approvedDate?: InputMaybe<Scalars['DateTime']['input']>;
  bookletId?: InputMaybe<Scalars['ObjectId']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  coupons?: InputMaybe<Array<InputMaybe<CouponInput>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  messageToCompany?: InputMaybe<Scalars['String']['input']>;
  sentDate?: InputMaybe<Scalars['DateTime']['input']>;
  sentToEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBookletCompanyReviewWithTokenArgs = {
  approvedDate?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationUpdateBookletSeriesArgs = {
  _id: Scalars['ObjectId']['input'];
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorLeft?: InputMaybe<Scalars['String']['input']>;
  colorRight?: InputMaybe<Scalars['String']['input']>;
  colorSalesMaterial?: InputMaybe<Scalars['String']['input']>;
  defaultValidityMonths?: InputMaybe<Scalars['Int']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  mainAssociationId?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postsButtonLabel?: InputMaybe<Scalars['String']['input']>;
  postsButtonLink?: InputMaybe<Scalars['String']['input']>;
  postsTitle?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  purchasableThroughAssociations?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  supportCommissionToAssociation?: InputMaybe<Scalars['Float']['input']>;
  supportCommissionToMainAssociation?: InputMaybe<Scalars['Float']['input']>;
  totalCommission?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateBroadcastArgs = {
  _id: Scalars['ObjectId']['input'];
  broadcastPeriod: BroadcastPeriodInput;
  broadcastType: Scalars['String']['input'];
  content: ContentInput;
  filters?: InputMaybe<FiltersInput>;
  notification?: InputMaybe<NotificationInput>;
};


export type MutationUpdateCityArgs = {
  _id: Scalars['ObjectId']['input'];
  activeFrom?: InputMaybe<Scalars['Int']['input']>;
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  bookletColorFont?: InputMaybe<Scalars['String']['input']>;
  bookletColorLeft?: InputMaybe<Scalars['String']['input']>;
  bookletColorRight?: InputMaybe<Scalars['String']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateCompanyArgs = {
  _id: Scalars['ObjectId']['input'];
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  companyCategoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  contactMobile?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  earlyBird?: InputMaybe<Scalars['Boolean']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  mainSponsor?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
  visitAddress?: InputMaybe<AddressInput>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyCategoryArgs = {
  _id: Scalars['ObjectId']['input'];
  iconPath?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCouponArgs = {
  _id: Scalars['ObjectId']['input'];
  assessment?: InputMaybe<CouponAssessmentInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  codeType?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  estimatedSavings?: InputMaybe<Scalars['Float']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  productLink?: InputMaybe<Scalars['String']['input']>;
  smallTitle?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCouponPositionsArgs = {
  newCoupons: Array<UpdateCouponPositionInput>;
};


export type MutationUpdateMyUserArgs = {
  appTutorialVersion?: InputMaybe<Scalars['Int']['input']>;
  associationTutorialVersion?: InputMaybe<Scalars['Int']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  marketingApprovedVersion?: InputMaybe<Scalars['Int']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  teamMemberTutorialVersion?: InputMaybe<Scalars['Int']['input']>;
  teamTutorialVersion?: InputMaybe<Scalars['Int']['input']>;
  termsApprovedVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateOrderArgs = {
  associationId?: InputMaybe<Scalars['ObjectId']['input']>;
  bookletId?: InputMaybe<Scalars['ObjectId']['input']>;
  completedDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderId: Scalars['ObjectId']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  supportAssociationId?: InputMaybe<Scalars['ObjectId']['input']>;
  teamId?: InputMaybe<Scalars['ObjectId']['input']>;
  teamMemberId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationUpdateOrderOwnerArgs = {
  code: Scalars['String']['input'];
  userId: Scalars['ObjectId']['input'];
};


export type MutationUpdateOrderSupportAssociationArgs = {
  orderId: Scalars['ObjectId']['input'];
  supportAssociationId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationUpdatePostArgs = {
  _id: Scalars['ObjectId']['input'];
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateTagArgs = {
  _id: Scalars['ObjectId']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationUpdateTeamArgs = {
  _id: Scalars['ObjectId']['input'];
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  bankInformation?: InputMaybe<BankInformationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  paidOutByBooklet?: InputMaybe<Array<PaidOutAmountInput>>;
  salesEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  salesStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  useAssociationPaymentInfo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateTeamMemberArgs = {
  _id: Scalars['ObjectId']['input'];
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  isApprovedByGuardian?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUsedCouponArgs = {
  savings: Scalars['Float']['input'];
  usedCouponId: Scalars['ObjectId']['input'];
};


export type MutationUpdateUserArgs = {
  _id: Scalars['ObjectId']['input'];
  appTutorialVersion?: InputMaybe<Scalars['Int']['input']>;
  associationTutorialVersion?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  marketingApprovedVersion?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  superAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  teamMemberTutorialVersion?: InputMaybe<Scalars['Int']['input']>;
  teamTutorialVersion?: InputMaybe<Scalars['Int']['input']>;
  termsApprovedVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateZoneArgs = {
  _id: Scalars['ObjectId']['input'];
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ObjectRightsCache = {
  __typename?: 'ObjectRightsCache';
  objectId?: Maybe<Scalars['ObjectId']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  _id: Scalars['ObjectId']['output'];
  associationId?: Maybe<Scalars['ObjectId']['output']>;
  associationName?: Maybe<Scalars['String']['output']>;
  batchLabel?: Maybe<Scalars['String']['output']>;
  bookletId: Scalars['ObjectId']['output'];
  bookletPrice?: Maybe<Scalars['Float']['output']>;
  bookletTax?: Maybe<Scalars['Float']['output']>;
  bookletTitle?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  paidAmount?: Maybe<Scalars['Int']['output']>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  period?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  supportAssociationId?: Maybe<Scalars['ObjectId']['output']>;
  swishNumber?: Maybe<Scalars['String']['output']>;
  swishStatus?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['ObjectId']['output']>;
  teamMemberFirstname?: Maybe<Scalars['String']['output']>;
  teamMemberId?: Maybe<Scalars['ObjectId']['output']>;
  teamMemberLastname?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  type: OrderType;
  userFirstname?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
  userLastname?: Maybe<Scalars['String']['output']>;
};

export enum OrderType {
  Purchase = 'PURCHASE',
  Voucher = 'VOUCHER'
}

export type PaidOutAmount = {
  __typename?: 'PaidOutAmount';
  amount: Scalars['Int']['output'];
  bookletId: Scalars['ObjectId']['output'];
};

export type PaidOutAmountInput = {
  amount: Scalars['Int']['input'];
  bookletId: Scalars['ObjectId']['input'];
};

export enum PaymentMethod {
  Invoice = 'INVOICE',
  Swish = 'SWISH'
}

export type Period = {
  __typename?: 'Period';
  currentPeriod?: Maybe<Scalars['Int']['output']>;
  fromPeriod: Scalars['Int']['output'];
  toPeriod: Scalars['Int']['output'];
};

export type Post = {
  __typename?: 'Post';
  _id: Scalars['ObjectId']['output'];
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  imageFullURL?: Maybe<Scalars['String']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
  validityStatus: PostValidity;
  zoneId: Scalars['ObjectId']['output'];
};

export enum PostValidity {
  Expired = 'EXPIRED',
  Upcoming = 'UPCOMING',
  Valid = 'VALID'
}

export enum PosterType {
  Association = 'ASSOCIATION',
  ClassTrip = 'CLASS_TRIP',
  Graduation = 'GRADUATION',
  Team = 'TEAM'
}

export type PublicAssociation = {
  __typename?: 'PublicAssociation';
  _id: Scalars['ObjectId']['output'];
  logoFullURL?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shopShareDomain?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subshopVisibilityInDashboard?: Maybe<SubshopVisibilityMode>;
};

export type PublicPeriod = {
  __typename?: 'PublicPeriod';
  bookletTitle?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  seasonName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicZone = {
  __typename?: 'PublicZone';
  _id?: Maybe<Scalars['ObjectId']['output']>;
};

export type Query = {
  __typename?: 'Query';
  allActiveBooklets?: Maybe<Array<Maybe<City>>>;
  allBookletSeries: Array<BookletSeries>;
  association?: Maybe<Association>;
  associationBySlug?: Maybe<Association>;
  associationPublic?: Maybe<PublicAssociation>;
  associations: Array<Association>;
  associationsInZone: Array<Association>;
  batchBookletCompanyReviews?: Maybe<Array<BookletCompanyReview>>;
  booklet?: Maybe<Booklet>;
  bookletByReviewToken?: Maybe<Booklet>;
  bookletCompanyReview?: Maybe<BookletCompanyReview>;
  bookletCompanyReviewByToken: BookletCompanyReview;
  bookletCompanyReviews?: Maybe<Array<BookletCompanyReview>>;
  bookletResellerStats: BookletResellerStats;
  bookletSeriesInZone: Array<BookletSeries>;
  booklets?: Maybe<Array<Booklet>>;
  bookletsInZone?: Maybe<Array<Booklet>>;
  broadcasts?: Maybe<Array<Broadcast>>;
  buyableBooklets?: Maybe<Array<Booklet>>;
  buyableBookletsAuthenticated?: Maybe<Array<Booklet>>;
  categoriesInBooklet?: Maybe<Array<CompanyCategory>>;
  companiesEmailRecords?: Maybe<Array<EmailRecord>>;
  companiesInZone?: Maybe<Array<Company>>;
  company?: Maybe<Company>;
  companyCategories?: Maybe<Array<CompanyCategory>>;
  companyEmailRecords?: Maybe<Array<EmailRecord>>;
  companyFromBooklet: CalculatedCompany;
  companyTypes?: Maybe<Array<CompanyType>>;
  completedOrdersByBooklet?: Maybe<Array<Order>>;
  coupon?: Maybe<Coupon>;
  couponCodeTypes?: Maybe<Array<Scalars['String']['output']>>;
  couponPositions?: Maybe<Array<CouponPosition>>;
  coupons?: Maybe<Array<Coupon>>;
  couponsInCompany?: Maybe<Array<Coupon>>;
  couponsReviewEmailRecord: EmailRecord;
  couponsReviewEmailRecordZone: EmailRecord;
  couponsReviewEmailRecords?: Maybe<Array<EmailRecord>>;
  currentPeriod: PublicPeriod;
  currentTerms: Terms;
  dashboardAssociationBooklets?: Maybe<Array<Booklet>>;
  earlyBirds: Array<EarlyBird>;
  getPeriods: Array<PublicPeriod>;
  myAdminableBooklets?: Maybe<Array<Booklet>>;
  myBroadcasts?: Maybe<Array<Broadcast>>;
  myOrder?: Maybe<Order>;
  notOwnedActiveBooklets?: Maybe<Array<Maybe<City>>>;
  ongoingPeriodsInAssociation: Period;
  orderByCode?: Maybe<Order>;
  ordersByTeamMember?: Maybe<Array<Order>>;
  post?: Maybe<Post>;
  postsForZone: Array<Post>;
  statAllOrders: StatOrders;
  statAllOrdersForZones: StatOrders;
  statAssociationTopTeamMembers: StatTopTeamMembers;
  statAssociationTopTeams: StatTopTeams;
  statOrdersByAssociation: StatOrders;
  statOrdersByTeam: StatOrders;
  statOrdersByTeamMember: StatOrders;
  statTeamTopTeamMembers: StatTopTeamMembers;
  tag: Tag;
  tags: Array<Tag>;
  tagsForZone: Array<Tag>;
  team?: Maybe<Team>;
  teamBySlug?: Maybe<Team>;
  teamMember?: Maybe<TeamMember>;
  teamMemberBySlug?: Maybe<TeamMember>;
  teamMembersInTeam?: Maybe<Array<TeamMember>>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamsInAssociation?: Maybe<Array<Maybe<Team>>>;
  unusedOrderByCode: Order;
  usedCoupons: Array<UsedCoupon>;
  user?: Maybe<User>;
  userExists: Scalars['Boolean']['output'];
  usersWithOrders?: Maybe<Array<CalculatedUser>>;
  visibleAssociationsWithTeams: Array<Association>;
  zone?: Maybe<Zone>;
  zones?: Maybe<Array<Maybe<Zone>>>;
  zonesForIds?: Maybe<Array<Maybe<Zone>>>;
  zonesPublic?: Maybe<Array<Maybe<PublicZone>>>;
};


export type QueryAssociationArgs = {
  associationId: Scalars['ObjectId']['input'];
};


export type QueryAssociationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryAssociationPublicArgs = {
  associationId: Scalars['ObjectId']['input'];
};


export type QueryAssociationsInZoneArgs = {
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryBatchBookletCompanyReviewsArgs = {
  bookletIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type QueryBookletArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryBookletByReviewTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryBookletCompanyReviewArgs = {
  bookletId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
};


export type QueryBookletCompanyReviewByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryBookletCompanyReviewsArgs = {
  bookletId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
};


export type QueryBookletResellerStatsArgs = {
  associationId: Scalars['ObjectId']['input'];
  bookletId: Scalars['ObjectId']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryBookletSeriesInZoneArgs = {
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryBookletsArgs = {
  filterOwned?: InputMaybe<Scalars['Boolean']['input']>;
  filterValid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBookletsInZoneArgs = {
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryCategoriesInBookletArgs = {
  bookletId: Scalars['ObjectId']['input'];
};


export type QueryCompaniesEmailRecordsArgs = {
  companyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryCompaniesInZoneArgs = {
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryCompanyArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryCompanyEmailRecordsArgs = {
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryCompanyFromBookletArgs = {
  bookletId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
};


export type QueryCompletedOrdersByBookletArgs = {
  bookletId: Scalars['ObjectId']['input'];
};


export type QueryCouponArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryCouponsInCompanyArgs = {
  companyId: Scalars['ObjectId']['input'];
};


export type QueryCouponsReviewEmailRecordArgs = {
  reviewId: Scalars['ObjectId']['input'];
};


export type QueryCouponsReviewEmailRecordZoneArgs = {
  reviewId: Scalars['ObjectId']['input'];
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryCouponsReviewEmailRecordsArgs = {
  bookletId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryDashboardAssociationBookletsArgs = {
  associationId: Scalars['ObjectId']['input'];
  teamId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryMyAdminableBookletsArgs = {
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryMyBroadcastsArgs = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  expoToken?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformVersion?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyOrderArgs = {
  orderId: Scalars['ObjectId']['input'];
};


export type QueryOngoingPeriodsInAssociationArgs = {
  associationId: Scalars['ObjectId']['input'];
};


export type QueryOrderByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryOrdersByTeamMemberArgs = {
  teamMemberId: Scalars['ObjectId']['input'];
};


export type QueryPostArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryPostsForZoneArgs = {
  filter?: InputMaybe<Array<PostValidity>>;
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryStatAllOrdersArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryStatAllOrdersForZonesArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  zoneIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type QueryStatAssociationTopTeamMembersArgs = {
  associationId: Scalars['ObjectId']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryStatAssociationTopTeamsArgs = {
  associationId: Scalars['ObjectId']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryStatOrdersByAssociationArgs = {
  associationId: Scalars['ObjectId']['input'];
  bookletId?: InputMaybe<Scalars['ObjectId']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryStatOrdersByTeamArgs = {
  bookletId?: InputMaybe<Scalars['ObjectId']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  teamId: Scalars['ObjectId']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryStatOrdersByTeamMemberArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  teamMemberId: Scalars['ObjectId']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryStatTeamTopTeamMembersArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  teamId: Scalars['ObjectId']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTagArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTagsForZoneArgs = {
  zoneId: Scalars['ObjectId']['input'];
};


export type QueryTeamArgs = {
  teamId: Scalars['ObjectId']['input'];
};


export type QueryTeamBySlugArgs = {
  associationSlug: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryTeamMemberArgs = {
  teamMemberId: Scalars['ObjectId']['input'];
};


export type QueryTeamMemberBySlugArgs = {
  associationSlug: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
};


export type QueryTeamMembersInTeamArgs = {
  includeNotApprovedByGuardian?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['ObjectId']['input'];
};


export type QueryTeamNameArgs = {
  teamId: Scalars['ObjectId']['input'];
};


export type QueryTeamsInAssociationArgs = {
  associationId: Scalars['ObjectId']['input'];
};


export type QueryUnusedOrderByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryUsedCouponsArgs = {
  bookletId: Scalars['ObjectId']['input'];
};


export type QueryUserExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryUsersWithOrdersArgs = {
  searchInput?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisibleAssociationsWithTeamsArgs = {
  domain: Scalars['String']['input'];
};


export type QueryZoneArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryZonesForIdsArgs = {
  zoneIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type ReadBy = {
  __typename?: 'ReadBy';
  bookletId?: Maybe<Scalars['ObjectId']['output']>;
  expoToken?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export type ReadByInput = {
  bookletId?: InputMaybe<Scalars['ObjectId']['input']>;
  expoToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum RegenerateType {
  Assessment = 'ASSESSMENT',
  AssessmentFields = 'ASSESSMENT_FIELDS',
  Coupon = 'COUPON'
}

export type ResellerStatTotals = {
  __typename?: 'ResellerStatTotals';
  totalEarnings: Scalars['Int']['output'];
  totalSold: Scalars['Int']['output'];
};

export type ResourceBank = {
  __typename?: 'ResourceBank';
  password?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ResourceBankInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ReturnCoupon = {
  __typename?: 'ReturnCoupon';
  calculatedCompanies: Array<CalculatedCompany>;
  cities?: Maybe<Array<CalculatedCity>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReturnStatus = {
  __typename?: 'ReturnStatus';
  orderId?: Maybe<Scalars['ObjectId']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Slide = {
  __typename?: 'Slide';
  button: Button;
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SlideInput = {
  button: ButtonInput;
  icon?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type Sponsor = {
  __typename?: 'Sponsor';
  categoryId?: Maybe<Scalars['ObjectId']['output']>;
  logoURL: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SponsorInput = {
  categoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  logoURL: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StatCoupon = {
  __typename?: 'StatCoupon';
  company: Company;
  coupon: Coupon;
};

export type StatCouponCounter = {
  __typename?: 'StatCouponCounter';
  active: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StatCoupons = {
  __typename?: 'StatCoupons';
  agreement: StatCouponCounter;
  season1: StatCouponCounter;
  season2: StatCouponCounter;
  season3: StatCouponCounter;
};

export type StatCouponsGroup = {
  __typename?: 'StatCouponsGroup';
  all: StatCoupons;
  topAgreement: Array<StatCoupon>;
  topSeason: Array<StatCoupon>;
  used: StatUsedCoupons;
};

export type StatOrders = {
  __typename?: 'StatOrders';
  generatedCompletedOrders?: Maybe<Array<Order>>;
  totalNumber: Scalars['Int']['output'];
  totalUsedOrders: Scalars['Int']['output'];
  webshopEarnings: Scalars['Int']['output'];
  webshopOrders?: Maybe<Array<Order>>;
};

export type StatPeriod = {
  __typename?: 'StatPeriod';
  amount: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  period: Scalars['Int']['output'];
};

export type StatTopTeam = {
  __typename?: 'StatTopTeam';
  team: Team;
  total: Scalars['Int']['output'];
};

export type StatTopTeamMember = {
  __typename?: 'StatTopTeamMember';
  teamMember: TeamMember;
  total: Scalars['Int']['output'];
};

export type StatTopTeamMembers = {
  __typename?: 'StatTopTeamMembers';
  teamMembers: Array<StatTopTeamMember>;
};

export type StatTopTeams = {
  __typename?: 'StatTopTeams';
  teams: Array<StatTopTeam>;
};

export type StatUsedCoupons = {
  __typename?: 'StatUsedCoupons';
  agreement: Scalars['Int']['output'];
  season1: Scalars['Int']['output'];
  season2: Scalars['Int']['output'];
  season3: Scalars['Int']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  orderStatusChanged?: Maybe<ReturnStatus>;
};


export type SubscriptionOrderStatusChangedArgs = {
  orderId: Scalars['ObjectId']['input'];
};

export enum SubshopVisibilityMode {
  None = 'NONE',
  Teams = 'TEAMS',
  TeamsAndMembers = 'TEAMS_AND_MEMBERS',
  TeamMembers = 'TEAM_MEMBERS'
}

export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['ObjectId']['output'];
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
  zoneId: Scalars['ObjectId']['output'];
};

export type Team = {
  __typename?: 'Team';
  _id: Scalars['ObjectId']['output'];
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminInvitations?: Maybe<Array<Maybe<AdminInvitation>>>;
  adminToken?: Maybe<Scalars['String']['output']>;
  adminUsers: Array<User>;
  associationId: Scalars['ObjectId']['output'];
  associationSlug?: Maybe<Scalars['String']['output']>;
  bankInformation?: Maybe<BankInformation>;
  bankInformationEncrypted?: Maybe<Scalars['String']['output']>;
  decryptedAdminToken?: Maybe<Scalars['String']['output']>;
  decryptedTeamMemberCreationToken?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orders?: Maybe<Array<Order>>;
  paidOutByBooklet?: Maybe<Array<PaidOutAmount>>;
  salesEndDate?: Maybe<Scalars['DateTime']['output']>;
  salesExtensionToken?: Maybe<Scalars['String']['output']>;
  salesStartDate?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  teamMemberCreationToken?: Maybe<Scalars['String']['output']>;
  teamMembers: Array<TeamMember>;
  useAssociationPaymentInfo?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamAdmin = {
  __typename?: 'TeamAdmin';
  _id: Scalars['ObjectId']['output'];
  associationId: Scalars['ObjectId']['output'];
  associationLogoFullURL?: Maybe<Scalars['String']['output']>;
  associationLogoURL?: Maybe<Scalars['String']['output']>;
  associationName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  _id: Scalars['ObjectId']['output'];
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminInvitations?: Maybe<Array<Maybe<AdminInvitation>>>;
  adminToken?: Maybe<Scalars['String']['output']>;
  adminUsers: Array<User>;
  associationSlug?: Maybe<Scalars['String']['output']>;
  decryptedAdminToken?: Maybe<Scalars['String']['output']>;
  firstLoginDate?: Maybe<Scalars['DateTime']['output']>;
  firstname: Scalars['String']['output'];
  isApprovedByGuardian?: Maybe<Scalars['Boolean']['output']>;
  lastname: Scalars['String']['output'];
  orders?: Maybe<Array<Order>>;
  slug?: Maybe<Scalars['String']['output']>;
  soldBooklets?: Maybe<Scalars['Int']['output']>;
  teamId: Scalars['ObjectId']['output'];
  teamSlug?: Maybe<Scalars['String']['output']>;
};

export type TeamMemberAdmin = {
  __typename?: 'TeamMemberAdmin';
  _id: Scalars['ObjectId']['output'];
  adminEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  associationId: Scalars['ObjectId']['output'];
  associationLogoFullURL?: Maybe<Scalars['String']['output']>;
  associationLogoURL?: Maybe<Scalars['String']['output']>;
  associationName: Scalars['String']['output'];
  decryptedAdminToken?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  teamId: Scalars['ObjectId']['output'];
  teamName: Scalars['String']['output'];
};

export type TeamMemberStats = {
  __typename?: 'TeamMemberStats';
  afEarnings: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  earnings: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
  supportEarnings: Scalars['Int']['output'];
  supportSold: Scalars['Int']['output'];
  teamMember: TeamMember;
};

export type TeamStats = {
  __typename?: 'TeamStats';
  afEarnings: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  earnings: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
  supportEarnings: Scalars['Int']['output'];
  supportSold: Scalars['Int']['output'];
  team: Team;
};

export type Terms = {
  __typename?: 'Terms';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type UpdateCouponPositionInput = {
  _id: Scalars['ObjectId']['input'];
  position: Scalars['Int']['input'];
};

export type UsedCoupon = {
  __typename?: 'UsedCoupon';
  _id: Scalars['ObjectId']['output'];
  activationDateTime: Scalars['DateTime']['output'];
  booklet_price: Scalars['Float']['output'];
  code?: Maybe<Scalars['String']['output']>;
  codeType?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['ObjectId']['output'];
  company_logoURL: Scalars['String']['output'];
  company_name: Scalars['String']['output'];
  couponId: Scalars['ObjectId']['output'];
  coupon_description: Scalars['String']['output'];
  coupon_discount: Scalars['String']['output'];
  coupon_smallTitle: Scalars['String']['output'];
  coupon_terms: Scalars['String']['output'];
  orderId: Scalars['ObjectId']['output'];
  savings: Scalars['Float']['output'];
};

export type UsedCouponBooklet = {
  __typename?: 'UsedCouponBooklet';
  _id: Scalars['ObjectId']['output'];
  amount: Scalars['Int']['output'];
};

export type UsedCouponsResult = {
  __typename?: 'UsedCouponsResult';
  booklets?: Maybe<Array<UsedCouponBooklet>>;
  totalAmount: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ObjectId']['output'];
  activated: Scalars['Boolean']['output'];
  activeOrders?: Maybe<Array<Maybe<Order>>>;
  adminObjects?: Maybe<AdminObject>;
  appTutorialVersion?: Maybe<Scalars['Int']['output']>;
  associationTutorialVersion?: Maybe<Scalars['Int']['output']>;
  companyFavourites: Array<Scalars['ObjectId']['output']>;
  deActivatedDate?: Maybe<Scalars['DateTime']['output']>;
  deviceId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email: Scalars['String']['output'];
  facebookId?: Maybe<Scalars['String']['output']>;
  firstLogIn?: Maybe<Scalars['DateTime']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  lastLogIn?: Maybe<Scalars['DateTime']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  marketingApprovedVersion?: Maybe<Scalars['Int']['output']>;
  noticeTokens?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orders?: Maybe<Array<Maybe<Order>>>;
  previewModeBookletPeriodOffset?: Maybe<Scalars['Int']['output']>;
  previewModeShowHiddenBooklets?: Maybe<Scalars['Boolean']['output']>;
  superAdmin?: Maybe<Scalars['Boolean']['output']>;
  teamMemberTutorialVersion?: Maybe<Scalars['Int']['output']>;
  teamTutorialVersion?: Maybe<Scalars['Int']['output']>;
  termsApprovedVersion?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  usedCoupons: Array<UsedCoupon>;
};

export type Version = {
  __typename?: 'Version';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type VersionInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type Zone = {
  __typename?: 'Zone';
  _id: Scalars['ObjectId']['output'];
  adminEmails: Array<Scalars['String']['output']>;
  adminIds: Array<Scalars['ObjectId']['output']>;
  adminUsers: Array<User>;
  includeInAllBooklets?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type ZoneAdmin = {
  __typename?: 'ZoneAdmin';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};
